import { ProductInput } from '@/models/Import'
import { SimplifiedProduct } from '@/models/Product'
import { EditableAdvancedProperty, PropertyReturn } from '@/models/Property'
import { computed, Ref, ref } from 'vue'

export const usePropertyReturns = (
  property?: Ref<EditableAdvancedProperty | undefined>,
  product?: Ref<SimplifiedProduct | undefined>,
  productInput?: Ref<ProductInput | undefined>,
) => {
  const current = ref<PropertyReturn>() // memoisation variable

  const original = computed(() => property?.value?.get(product?.value)) // computed to make it reactive. no need to update every time current updates

  const updateCurrentPropertyReturn = () => {
    current.value = property?.value?.get(product?.value, productInput?.value)
  }

  return {
    original,
    current,
    updateCurrentPropertyReturn,
  }
}
